import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-old-settings',
    templateUrl: './old-settings.component.html',
    styleUrls: ['./old-settings.component.scss'],
    standalone: false
})
export class OldSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
